import { render, staticRenderFns } from "./ComboProductForm.vue?vue&type=template&id=23f56ae1&"
import script from "./ComboProductForm.vue?vue&type=script&lang=js&"
export * from "./ComboProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports